<template>
  <div class="min-h-screen">
    <div class="mt-4 w-full m-auto">
      <ChangePasswordPanel :message="validationError" @change-password="resetPassword" />
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const router = useRouter();
const validationError = ref("");

const resetPassword = (password: string, verifyPassword: string): void => {
  const data = new FormData();
  data.append("password", password);
  data.append("verifyPassword", verifyPassword);
  data.append("token", route.query["t"] + "");

  axios
    .post("/account/resetpass", data)
    .then((response) => {
      if (response.data.errors != null) {
        validationError.value = response.data.errors[0].message;
      } else {
        success("Password changed!", "");
        router.push({
          name: "admin-login",
        });
      }
    })
    .catch((e) => errorApi(e));
};
</script>
